import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { clips, clipTags } from "@/mocks/media";

export default function Clips() {
  const [activeTag, setActiveTag] = useState("all");

  const filtered =
    activeTag === "all" ? clips : clips.filter((clip) => clip.tag === activeTag);

  return (
    <section id="clips" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="Key Scenes"
              title="经典片段：按主题找到你想回看的部分"
              desc="这里收录了片中有代表性的桥段，并说明每个片段在故事里的位置与作用。用下方的标签可以按主题筛选，找到和你关注方向对应的内容。"
            />
          </Reveal>

          <div className="mt-8 flex flex-wrap gap-2 p-1 rounded-full bg-background-100 border border-background-200 w-fit max-w-full">
            {clipTags.map((tag) => {
              const isActive = tag.id === activeTag;
              const count =
                tag.id === "all"
                  ? clips.length
                  : clips.filter((c) => c.tag === tag.id).length;
              return (
                <button
                  key={tag.id}
                  type="button"
                  onClick={() => setActiveTag(tag.id)}
                  aria-pressed={isActive}
                  className={`inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full font-label text-sm transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-600 hover:text-primary-600 hover:bg-primary-50"
                  }`}
                >
                  {tag.label}
                  <span
                    className={`text-xs px-1.5 rounded-full ${
                      isActive
                        ? "bg-white/20 text-background-50"
                        : "bg-background-200 text-foreground-500"
                    }`}
                  >
                    {count}
                  </span>
                </button>
              );
            })}
          </div>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {filtered.map((clip, index) => (
              <Reveal key={clip.id} delay={index * 50}>
                <article className="group h-full flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-300 transition-colors">
                  <div className="relative w-full h-48 md:h-52 overflow-hidden">
                    <img
                      src={clip.image}
                      alt={`${clip.title} 场景氛围图`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    />
                    <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-foreground-950/70 text-background-50 font-label text-xs backdrop-blur">
                      <i className="ri-price-tag-3-line" />
                      {clip.tagLabel}
                    </span>
                  </div>
                  <div className="p-5 flex flex-col flex-1">
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                      {clip.title}
                    </h3>
                    <p className="mt-1 font-label text-xs text-primary-600">
                      {clip.scene}
                    </p>
                    <p className="mt-3 text-sm leading-relaxed text-foreground-600 flex-1">
                      {clip.desc}
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>

          {filtered.length === 0 ? (
            <p className="mt-10 text-center text-sm text-foreground-500">
              该主题下暂时没有片段，试试其他标签。
            </p>
          ) : null}
        </div>
      </div>
    </section>
  );
}